<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  created () {
    this.$store.getUserInfo()
  }
}
</script>

<style lang="less">
@import url("~@/assets/css/variable.css");
@import url("~@/assets/css/init.css");
@import url("~@/assets/css/ElementPlus.less");
@import url("App.less");
@import url("~@/assets/css/common.less");

#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  font-size: 0.16rem;
}
</style>
